import { IconType } from '@mm/icons';
import { colors } from '@mm/utils';
import classNames from 'classnames';
import React, { ReactNode } from 'react';
import { TextLink } from '../TextLink/TextLink';
import { ThreeDotMenu, ThreeDotMenuProps } from '../ThreeDotMenu/ThreeDotMenu';
import './FilterItem.pcss';

type FilterItemType<T> = T;

type Props<T> = {
  title: string;
  item: FilterItemType<T>;
  icon?: IconType;
  className?: string;
  isActive?: boolean;
  onClick?: (filterItem?: FilterItemType<T>) => void;
  count?: number;
  menuProps?: ThreeDotMenuProps;
  children?: string | ReactNode | Element[];
  showGreenMarker?: boolean;
  showNewLabel?: boolean;
};

export const FilterItem = <T,>({
  className,
  title,
  item,
  icon: Icon,
  isActive,
  onClick = () => {},
  count,
  menuProps,
  children,
  showGreenMarker,
  showNewLabel,
}: Props<T>) => {
  return (
    <TextLink
      onClick={() => onClick(item)}
      className={classNames(className, 'filter-item', {
        'filter-item--active': isActive,
      })}
      icon={Icon && <Icon color={isActive ? colors.accentBlue : undefined} />}
      count={count}
      showGreenMarker={showGreenMarker}
      showNewLabel={showNewLabel}
    >
      {title}
      {children}
      {menuProps && (
        <ThreeDotMenu
          {...menuProps}
          className={classNames('filter-item__menu', menuProps?.className)}
          onClick={e => {
            e.stopPropagation();
            if (menuProps?.onClick) {
              menuProps.onClick(e);
            }
          }}
        />
      )}
    </TextLink>
  );
};
